import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { getIndentClassName } from '../../styles';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import Comment from '../../../Comment/presets/Comment';
import Flex from '@wix/da-ds/pkg/Flex';
import ViewReplies from '../ViewReplies';
import s from './RecursiveComment.scss';
import { BiData } from '@wix/da-bi/pkg/events';
const RecursiveComment = (_param)=>{
    var { comment, index } = _param, props = _object_without_properties(_param, [
        "comment",
        "index"
    ]);
    const { maxDepth, commentableItemId, commentableTypeId, canPostComment, isReplyingToParent, commentComponent: CommentComponent = Comment, commentClassName, commentWrapperClassName, viewRepliesClassName, enableForumThreadRootlessThreadMode = false, setCommentRef, onCommentMouseOver, setVerticalIndicatorRef, onEditingStateChange, onOpenCommentModal, onThreadUpdated } = props;
    const { commentId, indent, isLeafComment, children, parentId, replies } = comment;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const logBiEvent = useBiLogger();
    const openReplies = useCallback(()=>{
        logBiEvent(BiData({
            evid: 185,
            itemid: commentableItemId,
            typeid: commentableTypeId,
            commentid: commentId,
            commenterid: comment.user.useridUuid
        }));
        // If we already in iframe just redirect
        if (window.self !== window.top) {
            window.location.assign(Url.commentLink(commentableTypeId, commentableItemId, commentId, undefined, true));
            return;
        }
        onOpenCommentModal(commentableTypeId, commentableItemId, commentId, comment);
    }, [
        commentableItemId,
        commentableTypeId,
        logBiEvent,
        onOpenCommentModal,
        comment,
        commentId
    ]);
    let hasMoreReplies = isLeafComment && replies > 0 && indent >= maxDepth;
    const indentClassName = getIndentClassName(indent, isMobile);
    // Special handling just for forum threads, deals with backend removing the root comment
    let hideParentIndicatorsIfIndentBelow;
    if (enableForumThreadRootlessThreadMode) {
        // This hides the parent lines as the parent is gone
        hideParentIndicatorsIfIndentBelow = 1;
        // We add 1 to indent as parent is gone and all idents are now one off
        hasMoreReplies = isLeafComment && replies > 0 && indent + 1 >= maxDepth;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames(indentClassName, s['comment-wrapper'], parentId && !isReplyingToParent && index > 0 && s['comment-wrapper-child'], hasMoreReplies && s['has-more-replies'], indent < hideParentIndicatorsIfIndentBelow && s['parent-indicators-hidden'], commentWrapperClassName),
        ref: (element)=>setCommentRef(commentId, element),
        "data-indent": indent,
        onMouseOver: ()=>onCommentMouseOver(commentId, parentId, isReplyingToParent)
    }, parentId && index > 0 && /*#__PURE__*/ React.createElement("div", {
        className: s['vertical-indicator'],
        ref: (element)=>setVerticalIndicatorRef(commentId, element)
    }), /*#__PURE__*/ React.createElement(CommentComponent, {
        key: `comment-${commentId}`,
        comment: comment,
        className: classnames(s['comment'], commentClassName),
        onReplyPosted: onThreadUpdated,
        onCommentUpdated: onThreadUpdated,
        canPostComment: !!canPostComment,
        onEditingStateChange: (state)=>onEditingStateChange(commentId, state)
    })), children && children.map((child)=>/*#__PURE__*/ React.createElement(RecursiveComment, _object_spread({
            key: `comment-wrap-${child.commentId}`,
            comment: child,
            index: child.index
        }, props))), hasMoreReplies && /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['view-replies-wrapper'], viewRepliesClassName, isMobile && indentClassName),
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(ViewReplies, {
        onClick: openReplies
    }, t('commentthread.control.viewReplies'))));
};
RecursiveComment.displayName = 'RecursiveComment';
export default RecursiveComment;
